import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "hero hero--video",
  "aria-labelledby": "hero-title"
}
const _hoisted_3 = ["autoplay"]
const _hoisted_4 = {
  class: "entry",
  "aria-labelledby": "entry-title"
}
const _hoisted_5 = { class: "home-wrap entry-in" }
const _hoisted_6 = { class: "entry-items" }
const _hoisted_7 = {
  id: "values",
  class: "values",
  "aria-labelledby": "values-title"
}
const _hoisted_8 = { class: "home-wrap" }
const _hoisted_9 = { class: "values-list" }
const _hoisted_10 = { class: "value-no" }
const _hoisted_11 = { class: "value-copy" }
const _hoisted_12 = { class: "short" }
const _hoisted_13 = { class: "desc" }
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = { class: "value-visual" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = {
  id: "why",
  class: "why",
  "aria-labelledby": "why-title"
}
const _hoisted_18 = { class: "home-wrap why-in" }
const _hoisted_19 = { class: "why-list reveal" }
const _hoisted_20 = { class: "number" }
const _hoisted_21 = {
  id: "process",
  class: "process",
  "aria-labelledby": "process-title"
}
const _hoisted_22 = { class: "home-wrap reveal" }
const _hoisted_23 = { class: "steps" }
const _hoisted_24 = { class: "n" }
const _hoisted_25 = {
  class: "final",
  "aria-labelledby": "final-title"
}
const _hoisted_26 = { class: "home-wrap reveal" }
const _hoisted_27 = { class: "buttons" }

import { onMounted, onUnmounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useAdminAuth } from '@/composables/useAdminAuth'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardPage',
  setup(__props) {

const { isAdminLoggedIn } = useAdminAuth()
const reduceMotion = ref(
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches,
)
const heroVideoEl = ref<HTMLVideoElement | null>(null)

function applyHeroPlaybackRate() {
  const video = heroVideoEl.value
  if (!video) return
  video.defaultPlaybackRate = 0.5
  video.playbackRate = 0.5
}
const progress = ref(0)
const route = useRoute()
let observer: IntersectionObserver | null = null

const serviceSummaries = [
  { label: '임금관리', desc: '복잡한 운영업무를 더 쉽게' },
  { label: '재무회계', desc: '기관 경영을 더 든든하게' },
  { label: '성장지원', desc: '수급자 발굴과 기관 성장 지원' },
]

const values = [
  {
    no: '01 / SIMPLICITY',
    title: '간편함.',
    short: '복잡한 운영업무를 더 쉽게',
    desc: '임금관리와 재무회계의 반복적인 실무를 정리하고, 기관 운영에 필요한 시간을 보다 효율적으로 사용할 수 있도록 돕습니다.',
    tags: ['임금관리', '재무회계', '업무 간소화'],
    image: '/main/simplicity.jpg?v=3',
    alt: '어지러운 서류 더미 옆에 파일 하나가 놓인 장면 — 복잡한 업무가 한곳으로',
  },
  {
    no: '02 / STABILITY',
    title: '안정감.',
    short: '기관 경영을 더 든든하게',
    desc: '장기요양기관의 업무 흐름을 이해하는 체계적인 지원으로 기관장과 실무자가 경영의 기본에 더 집중할 수 있도록 돕습니다.',
    tags: ['장기요양기관 특화', '체계적인 지원', '실무 중심'],
    image: '/main/stability.jpg?v=3',
    alt: '땅에 단단히 앉은 건물, 창에 불이 고르게 켜진 장면 — 흔들림 없는 안정감',
  },
  {
    no: '03 / GROWTH',
    title: '성장.',
    short: '수급자 발굴과 기관 성장 지원',
    desc: '새로운 수급자를 만나고 기존 수급자·보호자와의 관계를 더 깊게 만들 수 있도록, 현장에서 실천할 수 있는 마케팅 콘텐츠를 제공합니다.',
    tags: ['수급자 발굴', '만족도 향상', '마케팅 콘텐츠'],
    image: '/main/growth.jpg?v=3',
    alt: '열린 문으로 사람들이 들어가는 장면 — 새로운 만남과 기관의 성장',
  },
]

const reasons = [
  { title: '장기요양기관에 집중합니다.', desc: '방문요양·주야간보호·요양시설의 운영 특성을 고려합니다.' },
  { title: '실무에서 바로 이해할 수 있게.', desc: '복잡한 설명보다 실제 적용할 수 있는 정보와 방법을 지향합니다.' },
  { title: '운영과 성장을 함께 바라봅니다.', desc: '행정업무의 효율부터 새로운 수급자와의 만남까지 생각합니다.' },
  { title: '기관의 내일을 위한 콘텐츠.', desc: '기관장이 직접 실천할 수 있는 성장지원 아이디어를 나눕니다.' },
]

const steps = [
  { title: '상담 문의', desc: '기관에서 고민하는 운영·성장 과제를 이야기합니다.' },
  { title: '기관 상황 확인', desc: '기관 유형과 현재 필요한 지원 내용을 살펴봅니다.' },
  { title: '서비스 선택', desc: '임금관리·재무회계 등 필요한 서비스 범위를 확인합니다.' },
  { title: '성장 콘텐츠 활용', desc: '기관에서 활용할 마케팅 자료와 운영 노하우를 살펴봅니다.' },
]

function updateProgress() {
  const max = document.documentElement.scrollHeight - window.innerHeight
  progress.value = max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 0
}

onMounted(() => {
  const nodes = document.querySelectorAll('.home .reveal')
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reduced || !('IntersectionObserver' in window)) {
    nodes.forEach((el) => el.classList.add('is-in'))
  } else {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.add('is-in')
        observer?.unobserve(entry.target)
      })
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' })
    nodes.forEach((el) => observer?.observe(el))
  }
  applyHeroPlaybackRate()
  window.addEventListener('scroll', updateProgress, { passive: true })
  updateProgress()
  const id = route.hash.replace('#', '')
  if (id) {
    requestAnimationFrame(() => document.getElementById(id)?.scrollIntoView({ block: 'start' }))
  }
})

onUnmounted(() => {
  observer?.disconnect()
  window.removeEventListener('scroll', updateProgress)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "scroll-progress",
      style: _normalizeStyle({ width: `${progress.value}%` }),
      "aria-hidden": "true"
    }, null, 4),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("video", {
        ref_key: "heroVideoEl",
        ref: heroVideoEl,
        class: "hero-video",
        autoplay: !reduceMotion.value,
        muted: "",
        loop: "",
        playsinline: "",
        preload: "auto",
        poster: "/main/hero-poster.jpg",
        "aria-hidden": "true",
        onLoadedmetadata: applyHeroPlaybackRate,
        onPlay: applyHeroPlaybackRate
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("source", {
          src: "/main/hero.mp4",
          type: "video/mp4"
        }, null, -1)
      ]))], 40, _hoisted_3),
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"hero-overlay\" aria-hidden=\"true\"></div><div class=\"home-wrap hero-in\"><div class=\"hero-left\"><p class=\"hero-kicker\"><span class=\"kicker-line\" aria-hidden=\"true\"></span>장기요양기관의 운영과 성장을 돕는 전문 파트너</p><h1 id=\"hero-title\">운영은 더 쉽게.<br>경영은 더 든든하게.<br>성장은 함께.</h1><p class=\"hero-desc\">복잡한 임금관리와 재무회계의 부담을 덜고,<br>수급자 발굴과 만족도 향상을 위한 방법까지.<br>기관의 더 나은 내일을 장기요양지원센터가 함께 준비합니다.</p><ul class=\"hero-criteria\" aria-label=\"장기요양지원센터의 핵심 가치\"><li><span>01</span>간편함</li><li><span>02</span>안정감</li><li><span>03</span>성장</li></ul></div></div>", 2))
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("span", {
          id: "entry-title",
          class: "entry-label"
        }, "지원 서비스", -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(serviceSummaries, (item) => {
            return _createElementVNode("article", {
              key: item.label,
              class: "entry-item"
            }, [
              _createElementVNode("b", null, _toDisplayString(item.label), 1),
              _createElementVNode("span", null, _toDisplayString(item.desc), 1)
            ])
          }), 64))
        ])
      ])
    ]),
    _cache[13] || (_cache[13] = _createStaticVNode("<section id=\"brand\" class=\"brand\" aria-labelledby=\"brand-title\"><div class=\"home-wrap reveal\"><p class=\"sup\">001 / BRAND MANIFESTO</p><h2 id=\"brand-title\">기관 운영의 부담은 덜고,<br><span>성장의 가능성은 더하고.</span></h2><p class=\"brand-lead\">복잡한 운영업무에 쏟는 수고는 줄이고, 돌봄의 품질과 기관의 미래에 더 집중할 수 있도록. 장기요양지원센터는 운영을 돕는 데서 멈추지 않고, 성장의 방법까지 함께 고민합니다.</p></div></section>", 1)),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "section-head reveal" }, [
          _createElementVNode("div", null, [
            _createElementVNode("p", { class: "sup" }, "002 / THE THREE VALUES"),
            _createElementVNode("h2", { id: "values-title" }, [
              _createTextVNode("장기요양지원센터가 만드는"),
              _createElementVNode("br"),
              _createTextVNode("세 가지 변화.")
            ])
          ]),
          _createElementVNode("p", { class: "side" }, "기능보다 중요한 것은 기관이 얻는 변화입니다. 운영의 간편함, 경영의 안정감, 그리고 성장의 가능성.")
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(values, (value) => {
            return _createElementVNode("article", {
              key: value.no,
              class: "value-row reveal"
            }, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(value.no), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h3", null, _toDisplayString(value.title), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(value.short), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(value.desc), 1),
                _createElementVNode("ul", {
                  class: "value-tags",
                  "aria-label": `${value.title} 핵심 내용`
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("li", { key: tag }, _toDisplayString(tag), 1))
                  }), 128))
                ], 8, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: value.image,
                  alt: value.alt,
                  loading: "lazy"
                }, null, 8, _hoisted_16)
              ])
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "why-left reveal" }, [
          _createElementVNode("p", { class: "sup" }, "003 / WHY HAMWOORI"),
          _createElementVNode("h2", { id: "why-title" }, [
            _createTextVNode("운영을 넘어,"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "line" }, "성장까지"),
            _createElementVNode("br"),
            _createTextVNode("생각합니다.")
          ]),
          _createElementVNode("p", null, "장기요양지원센터는 장기요양기관이 실제로 마주하는 업무와 고민을 이해하고, 실무에 도움이 되는 서비스와 콘텐츠를 연결합니다.")
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reasons, (reason, index) => {
            return _createElementVNode("div", {
              key: reason.title,
              class: "why-item"
            }, [
              _createElementVNode("span", _hoisted_20, "0" + _toDisplayString(index + 1), 1),
              _createElementVNode("div", null, [
                _createElementVNode("b", null, _toDisplayString(reason.title), 1),
                _createElementVNode("p", null, _toDisplayString(reason.desc), 1)
              ])
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "sup" }, "004 / HOW TO BEGIN", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("h2", { id: "process-title" }, [
          _createTextVNode("시작은 필요한 것부터,"),
          _createElementVNode("br"),
          _createTextVNode("차근차근.")
        ], -1)),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, index) => {
            return _createElementVNode("div", {
              key: step.title,
              class: "step"
            }, [
              _createElementVNode("p", _hoisted_24, "STEP 0" + _toDisplayString(index + 1) + " /", 1),
              _createElementVNode("h3", null, _toDisplayString(step.title), 1),
              _createElementVNode("p", null, _toDisplayString(step.desc), 1)
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_25, [
      _cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "shape",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("div", _hoisted_26, [
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "small" }, "THE NEXT CHAPTER STARTS HERE", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("h2", { id: "final-title" }, [
          _createTextVNode("더 쉬운 운영."),
          _createElementVNode("br"),
          _createElementVNode("em", null, "더 나은 성장.")
        ], -1)),
        _cache[10] || (_cache[10] = _createElementVNode("p", null, [
          _createTextVNode("장기요양기관의 오늘과 내일을"),
          _createElementVNode("br"),
          _createTextVNode("장기요양지원센터가 함께합니다.")
        ], -1)),
        _createElementVNode("div", _hoisted_27, [
          (_unref(isAdminLoggedIn))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/info",
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("정보마당 둘러보기 ", -1),
                  _createElementVNode("span", { "aria-hidden": "true" }, "↗", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "photo-note" }, "본 페이지의 이미지는 브랜드 메시지를 표현하기 위한 AI 제작 이미지입니다. 실제 서비스 범위는 상담 시 확인해 주세요.", -1))
      ])
    ])
  ]))
}
}

})